import React from 'react';
import styled from 'styled-components';
import { Mixins } from 'planoplan-ui-kit/core/mixins';
import { Colors } from 'planoplan-ui-kit/core/colors';

export const Checkbox = ({ id, children, ...restProps }) => (
  <React.Fragment>
    <Input type="checkbox" id={id} {...restProps} />
    <Label htmlFor={id}>{children}</Label>
  </React.Fragment>
);

const Label = styled.label`
  position: relative;
  display: inline-flex;
  align-items: center;
  cursor: pointer;

  &:before {
    ${Mixins.transition('background-position, border-color')};
    content: '';
    display: inline-block;
    width: 34px;
    min-width: 34px;
    height: 34px;
    border-radius: 4px;
    border: solid 1px ${Colors.whisper};
    margin-right: 15px;
    background-color: ${Colors.white};
    background-size: 34px 34px;
    background-position: center -34px;
    background-repeat: no-repeat;
    background-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij4gICAgPGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4gICAgICAgIDxwYXRoIGQ9Ik0wIDBoMjR2MjRIMHoiLz4gICAgICAgIDxwYXRoIGZpbGw9IiMyNjlDRkYiIGZpbGwtcnVsZT0ibm9uemVybyIgZD0iTTkgMTYuMTdMNC44MyAxMmwtMS40MiAxLjQxTDkgMTkgMjEgN2wtMS40MS0xLjQxeiIvPiAgICA8L2c+PC9zdmc+);
  }

  &:hover:before {
    border: solid 1px ${Colors.light_gray};
  }
`;

const Input = styled.input`
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);

  &:checked + label:before {
    background-position: center center;
  }
`;
